import React from "react";
import { Link } from "react-router-dom";
import { analytics } from "../analytics";

/**
 * Every route into the consultation form. Wrapping them in one component
 * means the CTA click event can never drift out of sync between the hero,
 * the nav, the services section and the final CTA — and it records *which*
 * CTA started a booking, which is the question you actually want answered
 * when deciding what to change on the page.
 */
const BookCTA = ({
  ctaLocation,
  source = "consultation",
  className,
  children,
  onClick,
}) => (
  <Link
    to={`/book-consultation?source=${source}`}
    className={className}
    onClick={(e) => {
      analytics.ctaBookClick({
        cta_location: ctaLocation,
        cta_source: source,
        cta_text: typeof children === "string" ? children : undefined,
      });
      if (onClick) onClick(e);
    }}
  >
    {children}
  </Link>
);

export default BookCTA;
